export enum EOTypeEnum {
  MANUFACTURER = 1,
  IMPORTER = 2,
  WHOLESALER = 3,
  DISTRIBUTOR = 4,
  RETAILER = 5,
  OTHER = 6
}

export namespace EOTypeEnum {
  export function getClassName(): string {
    return 'EOTypeEnum';
  }
}
